export const IS_LOCAL = false;
export const IS_PRODUCTION = true;

export const PRODUCTION_FRONTEND_URL  = IS_PRODUCTION ? "https://codp.elaatmani.com/" : "https://purepixeltv.com/";
export const PRODUCTION_BACKEND_URL   = IS_PRODUCTION ? "https://codp-api.elaatmani.com/" : "https://api.purepixeltv.com/";

export const DEVELOPMENT_FRONTEND_URL = "http://localhost:8080/";
export const DEVELOPMENT_BACKEND_URL  = "http://localhost:8000/";
// Courier tracking portal base URL (append the tracking code to form a full link).
// Set to null if the courier has no public tracking portal.
export const COURIER_PORTAL_URL       = null; // e.g. "https://portal.orio.digital/track/"
export const PREFIX                   = "cod_";
export const DEFAULT_LANGUAGE         = "en";
export const CURRENCY                 = "PKR";

export const FRONTEND_URL = IS_LOCAL ? DEVELOPMENT_FRONTEND_URL : PRODUCTION_FRONTEND_URL;
export const BACKEND_URL  = IS_LOCAL ? DEVELOPMENT_BACKEND_URL  : PRODUCTION_BACKEND_URL;